<div d-flex align-items-end flex-column>
    <div class="modal-header">
        <h4 class="modal-title">AAMP</h4>
        <!--<button type="button" class="icon-btn px-ml-5 md-18 md-light" aria-label="Close"
                (click)="activeModal.dismiss('Cross click')">
        </button>-->
        <span class="logo-btn-small close white" (click)="activeModal.dismiss('Cross click')"></span>
    </div>
    <div class="d-flex flex-row px-p-10 px-py-5 bg-yellow" *ngIf="userNotification">
        <i class="material-icons md-18">error</i>
        <span class="px-ml-5">Maximum quota values cannot be ZERO. Please enter values greater than zero.</span>
    </div>
    <div class="modal-body">
        <form [formGroup]="form" novalidate>
            <div formArrayName="quotas" class="d-flex flex-column px-p-10">
                <div class="d-flex flex-row">
                    <div class="px-w-160">

                    </div>
                    <div class="px-w-140">
                        Notional:
                    </div>
                    <div class="px-w-90">
                    </div>
                </div>
                <ng-template ngFor let-item [ngForOf]="quotas?.controls" let-i="index">
                    <div class="d-flex flex-row px-mt-10" [formGroupName]="i">
                        <div class="px-w-160 text-right">
                            {{item.value.productName}} :
                        </div>
                        <div class="px-w-140 px-ml-5 input_style">
                            <div [class.error]="isInvalid(item)">
                                <input formControlName="maxQuota" class="form-control form-control-sm" type="text">
                                <div class="triangle" *ngIf="isInvalid(item)">
                                    <div class="error-message">
                                        <div *ngIf="item.hasError('required', 'maxQuota')">Required</div>
                                        <div *ngIf="item.hasError('pattern', 'maxQuota')">Only numbers are accepted.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-w-90 px-ml-5">
                            USD
                        </div>
                    </div>
                </ng-template>
            </div>
        </form>
    </div>
    <div class="modal-footer mt-auto">
        <button type="button" class="btn btn-sm btn-basic" (click)="activeModal.dismiss('Close click')">CANCEL</button>
        <button type="button" class="btn btn-sm btn-basic bnpp-btn" [disabled]="!form.valid"
                (click)="onUpdateQuotas()">
            UPDATE AAMP
        </button>
    </div>
</div>

